import axios from 'axios'
import {EntryDescInitTO} from 'generated/JavaTO'

export function fetchEntryDescInitIdMaps() {
	return axios.get<EntryDescInitTO[]>("../json/entryDescription/init")
}